<template lang="pug">

	div#componentCoordinates(v-if="coordinate")
		div(@click="expanded = !expanded", :class="{active : expanded}")
			span Lat: {{coordinate.lat.toFixed(4)}}
			span.ml-2 Lng: {{coordinate.lng.toFixed(4)}}
			i.ml-2.fa.fa-angle-up

		transition(name="el-zoom-in-bottom")

			div#container(v-show="expanded")
				form
					div.title Coordenadas geográficas

					div.m-3.body
						select.form-control.form-control-sm(:disabled="true")
							option(selected) Sirgas 2000 geográfico
					
						.form-row.mt-2
							.form-group.col-md-6
								label Latitude
								input.form-control.form-control-sm(placeholder="± 13.2827", v-model="latitude", 
									v-validate="'latitude|max_value:85|min_value:-85'", name="latitude")
								input-errors(name="latitude")

							.form-group.col-md-6
								label Longitude
								input.form-control.form-control-sm(placeholder="± 26.2589", v-model="longitude"
									v-validate="'longitude'", name="longitude")
								input-errors(name="longitude")

					div.footer.py-2

						div.col-md-12
							button.btn.btn-sm.btn-outline-secondary.float-left(type="button", @click="close()")
								i.mdi.mdi-close
								|  Cancelar

							button.btn.btn-sm.btn-primary.float-right(type="button", @click="showCoordinates()")
								i.mdi.mdi-check
								|  Aplicar

</template>

<script>

import markerStyles from '@/utils/markerStyles';

export default {

	name: 'Coordinates',

	data () {
		return {
			
			expanded: false,

			options: [
				{
					id: 1,
					label: 'Latitude / Longitude geográfico'
				},
				{
					id: 2,
					label: 'GMS geográfico'
				}
			],

			value: {
				id: 1
			},

			latitude: null,

			longitude: null
		};
	},

	computed: {

		coordinate () {
		
			return this.$store.state.mapa.coordinate;
		}
	},

	methods: {
		
		showCoordinates () {

			if (this.latitude && this.longitude) {

				this.$bus.$emit('mapa.addCoordinatePoint', {
					markerCode: 'CoordinatesComponent',
					lat: this.latitude,
					lng: this.longitude,
					markerStyle: markerStyles.coordinates,
					center: true,
					inspecionar: true
				});
			}

			this.close();
		},

		close () {

			this.longitude = null;
			this.latitude = null;
			this.$validator.reset();
			this.expanded = false;
		}
	}
};

</script>


<style lang="scss">

@import "../styles/mixins.scss";
@import '../styles/variaveis';

#componentCoordinates {
	
	color: $coordinates-color;
	background-color: $coordinates-bg;
	cursor: pointer;

	&:hover, .active {
		color: $coordinates-active-color;
	}

	#container {

		cursor: default;
		background: $coordinates-bg;
		color: $coordinates-color;
		border-radius: $default-border-radius;
		@include box-shadow(0px, 3px, 6px, rgba(0,0,0,0.16)); //TODO: Extrair
		position: absolute;
		bottom: $bottom-bar-height + 1;
		width: $coordinates-body-width;
		height: $coordinates-container-height;

		.body {
			height: $coordinates-body-height;
		}

		.title {
			display: block;
			text-align: center;
			width: 100%;
			padding: 0.25rem 1.5rem;
			font-weight: 600;
			font-size: $zoom-select-title-font-size;
			border-bottom: 1px solid $zoom-select-title-border-color;
			cursor: default;
		}

		.footer {
			padding-top: $coordinates-footer-padding-top;
			border-top: 1px solid $zoom-select-title-border-color;
		}

		label {
			display: inline-block;
			margin-bottom: 0.1rem;
		}

		.form-group {
			margin-bottom: 0;
		}
	}
}

</style>


// WEBPACK FOOTER //
// Coordinates.vue?1c7ac914